import { adminGetSubscriptions } from '../../../api'
import get from 'lodash.get'

function searchOrders (searchOptions) {
  return (dispatch, getState) => {
    dispatch(request())

    adminGetSubscriptions(searchOptions, get(getState(), 'adminUser.user.tokens.token', '')).fetchPromise
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error.toString()))
        }
      )
  }

  function request () { return { type: 'ADMIN_SEARCH_ORDERS_REQUEST' } }

  function success (response) {
    return {
      type: 'ADMIN_SEARCH_ORDERS_SUCCESS',
      payload: response
    }
  }

  function failure (error) { return { type: 'ADMIN_SEARCH_ORDERS_FAILURE', error } }
}

export const adminOrderActions = {
  searchOrders
}
